/**
 * Created by Mark on 05/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AreaChart, Area , XAxis, YAxis ,   Tooltip, Legend } from 'recharts';


const CustomTooltip  = React.createClass({
    propTypes: {
        type: React.PropTypes.string,
        payload:React.PropTypes.array,
        label: React.PropTypes.number,
    },

    getIntroOfPage(label) {
        if (label === 'Page A') {
            return "Page A is about men's clothing";
        } else if (label === 'Page B') {
            return "Page B is about women's dress";
        } else if (label === 'Page C') {
            return "Page C is about women's bag";
        } else if (label === 'Page D') {
            return "Page D is about household goods";
        } else if (label === 'Page E') {
            return "Page E is about food";
        } else if (label === 'Page F') {
            return "Page F is about baby food";
        }
    },

    render() {
        const { active } = this.props;




        if (active) {
            const { payload, label } = this.props;



            let response = [];
            for(var idx = 0 ; idx < payload.length; idx++)
            {
                let title = <FormattedMessage id={ String("ui-813")} defaultMessage={ "Download Report" } />;
                switch(payload[idx].dataKey){
                    case "total_writing" : title = <FormattedMessage id={ String("ui-120")} defaultMessage={ "Download Report" } />; break;
                    case "total_reading" : title = <FormattedMessage id={ String("ui-119")} defaultMessage={ "Download Report" } />; break;
                    case "total_speaking" : title = <FormattedMessage id={ String("ui-118")} defaultMessage={ "Download Report" } />; break;
                    case "total_listening" : title = <FormattedMessage id={ String("ui-117")} defaultMessage={ "Download Report" } />; break;
                }


                response.push(<p className="desc"><b>{title} </b> : <small className="desc">{payload[idx].value}</small></p>)
            }

            return (
                <div className="card">
                    <div className="card-header p-b-0 p-t-0">
                        {response}
                    </div>
                </div>
            );
        }

        return null;
    }
});

export default class AreaGraph extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            id: this.props.id || Math.random(),
            height:this.props.height || 100,
            dataKeys:props.dataKeys,
            data:props.data || []
        }
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    updateDimensions(){

        this.setState({width:document.getElementById(this.state.id).clientWidth})
    }

    componentWillReceiveProps(props){
        this.setState({data:props.data})
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize"   , this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    renderLines(){

        var lines = [];
        for(var idx = 0 ; idx < this.state.dataKeys.length; idx++)
        {
            lines.push(<Area key={"area-"+idx} type="monotone" dataKey={this.state.dataKeys[idx].key} fill={this.state.dataKeys[idx].fill} stroke={this.state.dataKeys[idx].fill} activeDot={{r: 8}}/>);
        }

        return lines;
    }

    render(){
        return(
            <div id={this.state.id}>
                <AreaChart width={this.state.width} height={this.state.height} data={this.state.data}>
                    <Tooltip  content={<CustomTooltip  data={this.state.data}/>}/>
                    <YAxis padding={{ top: 25 }} axisLine={false} tickLine={false} />
                    <XAxis dataKey="name" label="name" padding={{left: 0, right: 25}} axisLine={false} tickLine={false} />
                    {this.renderLines()}
                </AreaChart>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/graphs/WordsLearntGraph.js